const PropTypes = require('prop-types');
const React = require('react');

const RelatedArticleView = ({ article, onClick }) =>
  <div className="blog-post-related-article">
    <div className="pb-half">
      <a href={article._links.web.href} onClick={() => onClick(article.id)}>
        <img alt={article.title} src={article.photo} />
      </a>
    </div>
    <a
      href={article._links.web.href}
      onClick={() => onClick(article.id)}
      className="related-article-title serif strong"
    >
      {article.title}
    </a>
  </div>;

RelatedArticleView.propTypes = {
  article: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

module.exports = RelatedArticleView;



// WEBPACK FOOTER //
// ./javascripts/components/articles/related_article_view.jsx